import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

// DigiHome «Knapp»: 44 px / 36 px, radius 12 / 8. Primaer = DigiHome-lilla med moerk tekst; ink = svart; outline = «lys».
// Only colour/transform transition (never `all`); active press scales to 0.98.
const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-[color,background-color,border-color,transform,box-shadow] duration-200 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground/30 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-[hsl(var(--accent))] text-[hsl(var(--ink))] hover:bg-[hsl(var(--accent-hover))]",
        ink: "bg-foreground text-background hover:bg-[hsl(var(--charcoal))] dark:hover:bg-foreground/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "bg-card text-foreground shadow-[0_0_0_1px_hsl(var(--foreground)/0.1)] hover:bg-secondary",
        secondary: "bg-secondary text-foreground hover:bg-[hsl(var(--tint))]",
        soft: "bg-[hsl(var(--accent-soft))] text-[hsl(var(--accent-strong))] hover:bg-[hsl(var(--accent)/0.28)]",
        ghost: "text-foreground hover:bg-foreground/[0.06]",
        light: "bg-white/90 text-[hsl(var(--ink))] hover:bg-white",
        link: "text-foreground underline-offset-4 hover:underline rounded-none h-auto px-0",
      },
      size: {
        default: "h-11 px-5 text-[15px] rounded-[12px]",
        sm: "h-9 px-3.5 text-[13.5px] rounded-[8px]",
        lg: "h-12 px-6 text-[16px] rounded-[12px]",
        icon: "h-10 w-10 rounded-[10px]",
        "icon-sm": "h-9 w-9 rounded-[8px]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
